import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { AxiosErrorResponse } from "../interface/api_request";
import { JobIdProps } from "../interface/job_board";

// {{base_url}}v1/admin//jobs/:job_id/facility/:facility_id
export const apiGetApplicantionToJob = async (
  values: JobIdProps,
  page: string,
  filters: string,
) => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/applications/${values.jobId}/facility?page=${page}&${filters}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetJobApplicants = async (
  values: JobIdProps,
  page: string,
  filters: string,
  facilityId: string,
) => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/admin/jobs/${values.jobId}/facility/${facilityId}?page=${page}&${filters}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
